<template>
  <div id="SectionConfidence">
    <UIContainer class="SectionConfidence__container">
      <template #left>
        <img
          class="SectionConfidence__image"
          src="../assets/confidence/bg.avif"
          alt="Governance & Controls (Factors, Scope 2, Evidence Vault)"
          loading="lazy"
        />
      </template>

      <template #right>
        <div class="SectionConfidence__content">
          <ReviewCarousel />
        </div>
      </template>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import ReviewCarousel from '@/views/components/misc/ReviewCarousel.vue'
</script>

<style lang="scss" scoped>
#SectionConfidence {
  position: relative;
  padding: 4rem 0;

  .SectionConfidence__container {
    background-color: $color-ui-gray-cool-50;
    padding-top: 0;
    padding-bottom: 0;

    @include md {
      :deep(.UIContainer__grid) {
        display: flex;
        .UIContainer__left {
          width: 40%;
          padding: 2rem 1rem;
        }
        .UIContainer__right {
          width: 60%;
        }
      }
    }
  }

  .SectionConfidence__image {
    display: none;
    width: 100%;
    max-height: 32rem;
    border-radius: 1.5rem;

    @include md {
      display: block;
      right: 0;
    }
  }

  .SectionConfidence__content {
    @include md {
      margin-left: 2rem;
      height: 348px;
    }

    .ReviewCarousel {
      max-width: 100%;
    }
  }

  .SectionConfidence__title {
    @include font-size-20px();
    font-weight: 600;
    line-height: 1.2;
    color: $color-ui-gray-cool-900;
    margin-bottom: 1rem;

    @include md {
      @include font-size-24px();
    }
  }

  .SectionConfidence__features {
    display: grid;
    gap: 1.25rem;
    padding-left: 1rem;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .SectionConfidence__feature {
    @include font-size-18px();
    display: flex;
    align-items: center;
    color: $color-ui-gray-cool-600;
    gap: 0.75rem;
  }

  .SectionConfidence__feature-icon {
    --size: 1.75rem;
  }

  .SectionConfidence__cta {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
}
</style>
